export const BACKEND_API_URL = "http://localhost:21021";

export const $STM_Config = {
  img_proxy_prefix: "https://steemitimages.com/",
  ipfs_prefix: "https://steemitimages.com/",
};
